<template>
  <hm-content title="">
    <div class="page_tips_box">
      <p class="desc">
        你可用该标题的模板搭配不同的关键词使用，配置提交后关键词种类和顺序将不能修改
      </p>
    </div>
    <div class="tmplmsg_detail_box mod_default_box" id="js_detail_container">
      <div class="flex">
        <div class="tmplmsg_detail_preview">
          <div class="wx_mobile_panel tmplmsg_card">
            <div class="wx_mobile_panel_hd tmplmsg_card_hd">
              <div class="wx_mobile_cell flex item-center">
                <div class="wx_mobile_cell_hd">
                  <span
                    class="tmplmsg_owner_avatar radius_avatar text-center flex item-center flex-center"
                  >
                    <span class="hmicon icon-ziyuan1"></span>
                  </span>
                </div>
                <div class="wx_mobile_cell_bd tmplmsg_owner_nickname" title="">
                  公众号名
                </div>
              </div>
            </div>
            <div class="wx_mobile_panel_bd">
              <div class="tmplmsg_preview_title">{{ title }}</div>
              <div class="tmplmsg_preview_desc">
                {{ new Date().getFullYear() }}年{{
                  new Date().getMonth() + 1
                }}月
              </div>
              <ul class="tmplmsg_preview_meta_list simple_preview_box">
                <li
                  class="tmplmsg_preview_meta_item simple_preview_item flex item-center"
                  v-for="(v, i) in checkedList"
                  :key="i"
                >
                  <label for="" class="simple_preview_label">{{
                    v.name
                  }}</label>
                  <p class="simple_preview_value">{{ v.example }}</p>
                </li>
              </ul>
            </div>
            <div class="wx_mobile_panel_ft">
              <a
                class="wx_mobile_cell wx_mobile_cell_access wx_mobile_cell_link"
                href="javascript:;"
              >
                <div class="wx_mobile_cell_ft"></div>
                <div class="wx_mobile_cell_bd">查看详情</div>
              </a>
            </div>
          </div>
          <p class="tips_global text-center mt20">内容示例</p>
        </div>
        <div class="flex-1 tmplmsg_form select_tmplmsg_form">
          <div class="portable_editor">
            <div class="editor-inner">
              <div class="">
                通知类型
              </div>
              <div class="mt20">
                <el-select
                  size="small"
                  placeholder="选择通知类型"
                  v-model="keywords"
                  style="width: 200px"
                  filterable
                >
                  <el-option
                    :label="v.itemText"
                    :value="v.itemValue"
                    v-for="(v, i) in subscribeMsgTypeList"
                    :key="i"
                  ></el-option>
                </el-select>
              </div>
              <!-- <div class="mt20">
                应用小程序类型
              </div>
              <div class="mt20">
                <el-select
                  size="small"
                  placeholder="选择小程序类型"
                  v-model="miniprogramType"
                  style="width: 200px"
                  filterable
                >
                  <el-option label="商城" value="1"></el-option>
                  <el-option label="苗掌柜" value="2"></el-option>
                  <el-option label="我要核销" value="3"></el-option>
                  <el-option label="禾伙人" value="4"></el-option>
                  <el-option label="禾销" value="5"></el-option>
                  <el-option label="禾店掌" value="8"></el-option>
                </el-select>
              </div> -->
              <div class="mt20">
                <div>场景说明</div>
                <div class="mt20">
                  <el-input
                    size="small"
                    placeholder="模板服务场景"
                    v-model="sceneDesc"
                    maxlength="15"
                  ></el-input>
                </div>
              </div>
              <div class="mt20">
                配置关键词
              </div>
              <div class="tmplmsg_search_keywords_box">
                <div class="frm_input_box search with_del append attach_search">
                  <el-input
                    size="small"
                    class="no-boder"
                    style="width: 100%;"
                    @input="filterKeyword"
                    v-model="keyword"
                    placeholder="请输入关键词过滤"
                  ></el-input>
                </div>
                <el-scrollbar
                  ref="scrollContainer"
                  :vertical="false"
                  wrap-style="height: 150px;"
                >
                  <div class="tmplmsg_keywords_list">
                    <el-checkbox-group v-model="checkedList">
                      <div
                        class="tmplmsg_keywords_item"
                        v-for="(v, i) in filterResult"
                        :key="i"
                      >
                        <el-checkbox :label="v">{{ v.name }}</el-checkbox>
                      </div>
                    </el-checkbox-group>
                  </div>
                </el-scrollbar>
              </div>
              <div class="mt20">
                <span class="mr10">已选中的关键词</span>
                <span class="detail">拖拽可调整顺序</span>
              </div>
              <draggable
                class="tmplmsg_keywords_selected_list mt20"
                :list="checkedList"
              >
                <li
                  class="flex flex-between tmplmsg_keywords_selected_item"
                  v-for="(v, i) in checkedList"
                  :key="i"
                >
                  <div>{{ v.name }}</div>
                  <div>
                    <span class="hmicon icon-hanbaobao"></span>
                  </div>
                </li>
              </draggable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-wrapper flex flex-center mt20">
      <el-button size="small" type="primary" @click="save">保存</el-button>
      <el-button size="small" @click="$router.back(-1)">返回</el-button>
    </div>
  </hm-content>
</template>

<script>
import draggable from "vuedraggable";

export default {
  components: {
    draggable
  },
  data() {
    return {
      miniprogramType: "1",
      itemList: [],
      subscribeMsgTypeList: [],
      keyword: "",
      keywords: "",
      checkedList: [],
      filterResult: [],
      keywordList: [],
      title: "",
      sceneDesc: ""
    };
  },
  computed: {},
  watch: {},
  created() {
    this.title = this.$route.query.title;
    this.queryTempMsg();
    this.querySubscribeMsgType();
  },
  mounted() {},
  methods: {
    async querySubscribeMsgType() {
      const { result } = await this.$store.dispatch("queryGzhSubscribeMsgType");
      this.subscribeMsgTypeList = result;
    },
    filterKeyword() {
      this.filterResult = this.keywordList.filter(
        v => v.name.indexOf(this.keyword) > -1 && v
      );
    },
    async queryTempMsg() {
      const { result } = await this.$store.dispatch(
        "getPubTemplateKeyWordsById",
        {
          tid: this.$route.query.tid
        }
      );
      const { data } = result;
      this.keywordList = data;
      this.filterResult = data;
    },
    async save() {
      if (this.checkedList.length < 2) {
        this.$message({
          type: "warning",
          message: "请至少选择2个关键词"
        });
        return;
      }
      if (!this.sceneDesc) {
        this.$message({
          type: "warning",
          message: "请输入场景描述"
        });
        return;
      }
      const { code } = await this.$store.dispatch("addWxGzhTemplate", {
        tid: this.$route.query.tid,
        code: this.keywords,
        kidList: this.checkedList.map(v => v.kid),
        keywords: this.checkedList.map(v => v.name).join(","),
        title: this.title,
        sceneDesc: this.sceneDesc
      });
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.$router.back(-1);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tmplmsg_detail_preview {
  width: 320px;
  margin-right: 60px;
  line-height: 24px;
}

.tmplmsg_card {
  border: 1px solid #e7e7eb;
  border-radius: 5px;
  background-color: #fff;
  margin-top: 10px;
  overflow: hidden;
  position: relative;
}

.wx_mobile_panel_hd {
  padding: 14px 15px 10px;
  color: #9a9a9a;
  font-size: 13px;
  position: relative;
  border-bottom: 1px solid #e7e7eb;
}

.wx_mobile_cell {
  display: block;
  overflow: hidden;
  *zoom: 1;
  padding: 9px 15px;
  position: relative;
}

.tmplmsg_card .tmplmsg_owner_avatar {
  width: 32px;
  height: 32px;
  padding: 0;
  margin-right: 12px;
  display: block;
  img {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    background-color: #eee;
  }
}

.wx_mobile_panel_bd {
  min-height: 230px;
  padding: 15px;
}

.tmplmsg_card .tmplmsg_preview_desc {
  color: #9a9a9a;
  font-size: 12px;
}

.tmplmsg_preview_meta_list {
  padding: 30px 0;
  font-size: 13px;
}

.tmplmsg_card .tmplmsg_preview_meta_list .simple_preview_label {
  color: #9a9a9a;
  margin-right: 1em;
}

.tips_global {
  color: #9a9a9a;
}

.page_tips_box {
  padding-bottom: 20px;
  margin-bottom: 10px;
  border-bottom: 1px dashed #e7e7eb;
  .desc {
    color: #9a9a9a;
  }
}

.attach_search {
  display: block;
  width: auto;
  margin-bottom: -1px;
  border: 0;
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #e7e7eb;
  margin-bottom: 10px;
}

.portable_editor {
  position: relative;
  margin-top: 8px;
  &::before {
    position: absolute;
    top: 20px;
    left: -12px;
    width: 0;
    content: "";
    height: 0;
    border-width: 12px;
    border-style: dashed;
    border-color: transparent;
    border-left-width: 0;
    border-right-color: #f6f8f9;
    border-right-style: solid;
  }
  .editor-inner {
    background: #f6f8f9;
    padding: 40px 30px;
    border: 0;
  }

  .tmplmsg_search_keywords_box {
    background-color: #fff;
    border-radius: 4px;
    padding: 5px 20px;
    margin-top: 20px;
  }

  .tmplmsg_keywords_list {
    border-top-width: 0;
    padding-bottom: 20px;
    .tmplmsg_keywords_item {
      line-height: 40px;
      padding-left: 12px;
      margin-right: 0;
    }
  }

  .tmplmsg_keywords_selected_list {
    border-radius: 4px;
    padding: 5px 0;
    .tmplmsg_keywords_selected_item {
      background-color: #fff;
      line-height: 40px;
      padding: 0 12px;
      border-radius: 3px;
      cursor: move;
      margin-top: 5px;
    }
  }

  .detail {
    color: #999;
  }
}
</style>
